import { OnboardingPeriodScreen } from "@/components/screens/onboarding/PeriodScreen"
import { useAnalytics } from "@/hooks/use-analytics"
import { useCreateReport } from "@/queries/useReport"
import { useNavigate } from "@/router"
import { authAtom, setCurrentReportId, setKey } from "@/state/auth"
import { periodDraftAtom } from "@/state/draft/period"
import { useAtom, useAtomValue } from "jotai"
import { useEffect } from "react"

export default function OnboardingPeriodPage() {
	const navigate = useNavigate()
	const [state, setState] = useAtom(periodDraftAtom)
	const auth = useAtomValue(authAtom)
	const { mutateAsync: createReport } = useCreateReport()
	const { sendEvent } = useAnalytics("Create_Period")

	useEffect(() => {
		sendEvent("Step_Period__View")
	}, [])
	useEffect(() => {
		if (!auth.currentReportId) {
			createReport().then((response) => {
				setKey(response.id, response.key)
				setCurrentReportId(response.id)
			})
		}
	}, [auth])

	return (
		<OnboardingPeriodScreen
			value={state}
			onSubmit={(data) => {
				setState(data)
				sendEvent("Step_Period__Continue")
				navigate("/report/create/profession")
			}}
		/>
	)
}
